import { ReactNode, memo } from 'react';
import { Container } from './LayoutIcons.styles';

function LayoutIconsPureComponent({ children }: { children?: ReactNode }) {
  return <Container>{children}</Container>;
}

export const LayoutIcons = memo(LayoutIconsPureComponent);
